import React from "react";

import { PriceProps } from "@models/components/user.model";

const Price: React.FC<PriceProps> = ({
  customClass = "",
  label,
  labelClass,
  subLabel,
  value,
}) => {
  return (
    <div className={`row ${customClass}`}>
      <div className="col-7">
        <h5
          className={`fg-FS-14 ${labelClass || ""}`}
          data-testid="price-label"
        >
          {label}
          {subLabel && (
            <span data-testid="price-sub-label">{` (${subLabel})`}</span>
          )}
        </h5>
      </div>
      <div className="col-5 text-end">
        <h5 className="fg-FS-14" data-testid="price-text">
          {value || "-"}
        </h5>
      </div>
    </div>
  );
};

export default Price;
